import apiClient from "./axiosConfig";

export const getVendorsList = async (search = "", page = 1, pageSize = 25) => {
  try {
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (page) params.append("page", page);
    if (pageSize) params.append("page_size", pageSize);

    const queryString = params.toString();
    const url = queryString
      ? `/vendors/list/?${queryString}`
      : "/vendors/list/";

    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching vendors list:", error);
    throw error;
  }
};

export const getVendorById = async (vendorId) => {
  try {
    const response = await apiClient.get(`/vendors/${vendorId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching Supplier ${vendorId}:`, error);
    throw error;
  }
};

export const createVendor = async (vendorData) => {
  try {
    const response = await apiClient.post("/vendors/create/", vendorData);
    return response.data;
  } catch (error) {
    console.error("Error creating Supplier:", error);
    throw error;
  }
};

export const updateVendor = async (vendorId, vendorData) => {
  try {
    const response = await apiClient.put(`/vendors/${vendorId}`, vendorData);
    return response.data;
  } catch (error) {
    console.error(`Error updating Supplier ${vendorId}:`, error);
    throw error;
  }
};

export const deleteVendor = async (vendorId) => {
  try {
    const response = await apiClient.delete(`/vendors/${vendorId}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting Supplier ${vendorId}:`, error);
    throw error;
  }
};
